import CustomButton from 'components/buttons/CustomButton/CustomButton'
import React, { useState } from 'react'
import CreditCardIcon from '@mui/icons-material/CreditCard';
import UpgradeDialog from 'components/dialogs/UpgradeDialog';
import { useGetCurrentPlan } from 'hooks/usePlans';
import { snackbarService } from 'services/snackbarService';

interface Props {
    refetch?: () => void;
}

export default function UpgradePlanButton(props: Props) {
    const [open, setOpen] = useState<boolean>(false);
    const { data: plan } = useGetCurrentPlan();

    const openUpgradeDialog = () => {
        if (plan?.data?.is_subscription_cancelled) {
            snackbarService.showSnackbar("You can't manage your plans since you've cancelled your current subscription.", 'info', 5000);
        } else {
            setOpen(true);
        }
    }

    return (
        <>
            <CustomButton
                key='manage-plans'
                text='Manage plans'
                color='primary'
                icon={<CreditCardIcon sx={{ fontSize: '' }} />}
                onClick={openUpgradeDialog}
            />

            <UpgradeDialog
                {...props}
                open={open}
                setOpen={setOpen}
            />
        </>
    )
}
